import React from 'react';

import { motion } from "framer-motion";

import { useLang } from "../zustand/store.js";

import images from '../libs/images';
import consts from '../libs/consts';

export default function LangLoader() {

    const { lang } = useLang();

    return (
        <motion.div
            className="loader"
            initial={consts.loaderVariants.closed}
            animate={lang ? "closed" : "open"}
            variants={consts.loaderVariants}
        >
            <div className='loading_spin' />
        </motion.div>
    )    
}